/**
 * Copyright Mántum All Rights Reserved.
 */
import { useEffect } from 'react';

export default <T extends HTMLElement>(
    ref: React.RefObject<T>,
    handler: (event: Event) => void
) => {
    useEffect(() => {
        const listener = (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            if (!ref.current || ref.current.contains(target)) {
                return;
            }
            handler(event);
        };

        document.addEventListener('mousedown', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
        };
    }, [ref, handler]);
};
